<template>
  <div>
    <AppkitIcon
      icon="icon-hb-full-fill"
      size="xs"
      :style="{ color: getStatusCssClass(status) }"
      :display-tooltip="activateTooltip"
      :tooltip-text="tooltipText"
    />
    <span v-if="includeStatusText">{{
      answerStatusToDisplayText(status)
    }}</span>
  </div>
</template>

<script setup lang="ts">
import {
  AnswerStatus,
  answerStatusToDisplayText,
} from "@/models/enum/answerStatus";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";

withDefaults(
  defineProps<{
    status: AnswerStatus;
    includeStatusText?: boolean;
    activateTooltip?: boolean;
    tooltipText?: string;
  }>(),
  {
    includeStatusText: true,
    activateTooltip: false,
  }
);

function getStatusCssClass(status: string): string {
  switch (status) {
    case AnswerStatus.NotRegistered:
      return "var(--grey)";
    case AnswerStatus.InProgress:
      return "var(--status-yellow)";
    case AnswerStatus.NotStarted:
      return "var(--light-status-red)";
    case AnswerStatus.Completed:
      return "var(--light-status-green)";
    default:
      return "";
  }
}
</script>
